import { Edit as Edit_kojaro } from './Edit.kojaro';
import { Edit as Edit_phosphor } from './Edit.phosphor';
import { Edit as Edit_zoomg } from './Edit.zoomg';
import { Edit as Edit_zoomit } from './Edit.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Edit_kojaro;

    case 'zoomg':
      return Edit_zoomg;

    case 'phosphor':
      return Edit_phosphor;

    default:
      return Edit_zoomit;
  }
};

export const Edit = IconRenderer();
